import { render, staticRenderFns } from "./formEdit_news.vue?vue&type=template&id=6a7a6cf0&scoped=true"
import script from "./formEdit_news.vue?vue&type=script&lang=js"
export * from "./formEdit_news.vue?vue&type=script&lang=js"
import style0 from "./formEdit_news.vue?vue&type=style&index=0&id=6a7a6cf0&prod&lang=css&scoped=true"
import style1 from "./formEdit_news.vue?vue&type=style&index=1&id=6a7a6cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a6cf0",
  null
  
)

export default component.exports